import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import Button from "@limitless/modern/inputs/button/Button";
import Typography from "@limitless/modern/data-display/typography/Typography";
const useStyles = makeStyles(() => ({
  ctaContainer: {
    marginTop: 16
  },
  link: {
    "&:hover": {
      cursor: "pointer"
    }
  },
  button: {
    whiteSpace: "nowrap"
  }
}));
const LLMLandingCTA = ({
  content,
  onFormSubmit,
  isFormInvalid
}) => {
  const classes = useStyles();
  const {
    header,
    termsLabel,
    termsLink,
    buttonLabel
  } = content;
  const handleSubmit = () => {
    onFormSubmit(content);
  };
  const handleTermsClick = () => {
    window.open(termsLink, "_blank").focus();
  };
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.ctaContainer
  }, header && termsLabel && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, header), "\xA0", /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "primary",
    className: classes.link,
    onClick: handleTermsClick
  }, termsLabel)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4,
    md: 3,
    mb: 2
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "contained",
    disabled: isFormInvalid,
    id: "landingSubmitButton",
    onClick: handleSubmit,
    className: classes.button
  }, buttonLabel)));
};
export default LLMLandingCTA;
LLMLandingCTA.propTypes = {
  content: PropTypes.object.isRequired,
  isFormInvalid: PropTypes.bool,
  onFormSubmit: PropTypes.func
};